import { UseQueryResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { getAmazonCodeDataById } from '../apis'
import { AmazonCodeByIdDto } from '../apis/dto/amazon-codes.dto'
import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'

type UseAmazonCodeStats = (amazonCodeId: string) => UseQueryResult<AmazonCodeByIdDto | null, Error>

/**
 * This hook is responsible of getting the total number of available amazon codes
 */
export const useAmazonCodeDataById: UseAmazonCodeStats = amazonCodeId => {
  const authFetch = useAuthFetchWithResponse()

  const result = usePortalQuery({
    queryKey: ['users', 'amazon-codes', amazonCodeId],
    queryFn: () => getAmazonCodeDataById(amazonCodeId, authFetch),
    retry: 1,
  })

  return result
}
